const ComingSoonIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="40"
      cy="40"
      r="38"
      stroke="#14508c"
      strokeWidth="2"
      fill="#e8f0fb"
    />
    <circle
      cx="40"
      cy="40"
      r="28"
      stroke="#14508c"
      strokeWidth="1.5"
      strokeDasharray="5 3"
      fill="none"
    />
    <path
      d="M40 22v18l11 6.5"
      stroke="#14508c"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="40" cy="40" r="2.5" fill="#14508c" />
    <path
      d="M22 14l4 4M54 14l-4 4M22 66l4-4M54 66l-4-4"
      stroke="#14508c"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default ComingSoonIcon;
